module.exports = __webpack_public_path__ + "img/w3_mc_white.a27c5b93.png";